import axios from 'axios'
import platform from 'platform'
import MD5 from 'crypto-js/md5'
import Util from './util'

import Loading from 'muse-ui-loading'
import Message from 'muse-ui-message'
import NProgress from 'muse-ui-progress'

import 'muse-ui/dist/muse-ui.css'

import 'muse-ui-progress/dist/muse-ui-progress.css'
import 'muse-ui-loading/dist/muse-ui-loading.css'
import 'muse-ui-message/dist/muse-ui-message.css'

const http = axios.create()

http.loading = {}

http.rids = new Set()

http.openLoading = config => {
    NProgress.start()
    if (config.loading != undefined && !config.loading) {
        return
    }
    http.rids.add(config.rid)
    setTimeout(() => {
        if (http.rids.size > 0) {
            http.loading = Loading({
                text: '正在请求服务器...',
                overlayColor: 'rgba(0, 0, 0, 0.7)'
            })
        }
    }, 1000)
}
http.hideLoading = rid => {
    NProgress.done()
    if (rid === 'All') {
        http.rids.clear()
    } else {
        http.rids.delete(rid)
    }
    if (http.rids.size > 0) {
        return
    }
    setTimeout(() => {
        http.loading && http.loading.close && http.loading.close()
    }, 300)
}
http.msg = message => {
    Message({
        title: '提示',
        content: message,
        mode: 'alert'
    })
    // Message.alert(message, '提示', {
    //     type: 'error'
    // })
}

http.sign = () => {
    let token = 'Guest'
    let time = new Date().getTime() + ''
    let nonce = Math.random()
        .toString(36)
        .replace(/[^a-z]+/g, '')
    let version = 100001

    let _token = (token + Util.reverse(token)).substring(4, token.length * 2 - 4)
    let _nonce = Util.reverse(nonce)
    let _time = parseInt(time.substring(8)) * parseInt(time.substring(6, 8)) + ''
    let _sign = MD5(_time + '|' + _token + ':' + _nonce).toString()

    let sign = Util.reverse(MD5(_sign).toString()).substring(0, 8) + _sign + Util.reverse(MD5(_sign).toString()).substring(_sign.length - 8)

    return {
        Token: token,
        Nonce: nonce,
        Time: time,
        Version: version,
        Sign: sign
    }
}

http.root = () => {
    return process.env.VUE_APP_API_ROOT
}

http.defaults.baseURL = http.root()
http.defaults.timeout = 60 * 1000
http.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'
http.defaults.transformRequest = [
    function(data) {
        let form = new FormData()
        for (let key in data) {
            form.append(key, data[key])
        }
        return form
    }
]

http.interceptors.request.use(
    function(config) {
        // 设置接口请求头信息
        let signInfo = http.sign()
        config.headers['t'] = signInfo.Token
        config.headers['r'] = signInfo.Nonce
        config.headers['m'] = signInfo.Time
        config.headers['v'] = signInfo.Version
        config.headers['s'] = signInfo.Sign
        config.headers['c'] = platform.description

        config.rid = signInfo.Time + '' + Math.random()
        http.openLoading(config)
        return config
    },
    function(error) {
        http.hideLoading('All')
        http.msg('请求服务器失败')
        return Promise.reject(error)
    }
)

http.interceptors.response.use(
    function(response) {
        if (response.headers['content-type'].indexOf('json') >= 0) {
            if (response.data) {
                let json = response.data
                response.data = {
                    code: json.c,
                    time: json.t,
                    msg: json.m,
                    data: json.d,
                    datas: json.s
                }
            }

            if (response.data && response.data.code !== 0) {
                http.msg(response.data.msg)
            }
        }
        http.hideLoading(response.config.rid)
        return response.data
    },
    function(error) {
        http.hideLoading(error.config.rid)
        http.msg('请求服务器失败')
        return Promise.reject(error)
    }
)

export default http
